/**
 * Service d'authentification - ULTRA-DEBUG VERSION
 */

class AuthService {
  constructor() {
    this.TOKEN_KEY = 'authToken';
    this.USER_KEY = 'user';
    this.USER_EMAIL_KEY = 'user_email';
    this.SESSION_KEY = 'hasSession';
  }

  /**
   * Sauvegarder une session sans token (API session-based)
   */
  saveSession(userData) {
    if (!userData) throw new Error('userData requis pour saveSession');
    localStorage.setItem(this.USER_KEY, JSON.stringify(userData));
    localStorage.setItem(this.USER_EMAIL_KEY, userData.email || '');
    localStorage.setItem(this.SESSION_KEY, 'true');
  }

  /**
   * Sauvegarder le token et l'utilisateur
   */
  saveToken(token, userData) {
    // Étape 1: Vérifier le token
    if (!token) {
      console.error('   ❌ TOKEN VIDE!');
      throw new Error('Token vide');
    }

    // Étape 2: Formater le token
    const fullToken = token.startsWith('Bearer ') ? token : `Bearer ${token}`;

    // Étape 3: Sauvegarder dans localStorage
    try {
      localStorage.setItem(this.TOKEN_KEY, fullToken);
    } catch (e) {
      console.error('   ❌ Erreur setItem:', e.message);
      throw e;
    }

    // Étape 4: Vérifier immédiatement
    const verify = localStorage.getItem(this.TOKEN_KEY);
    if (!verify) {
      console.error('   ❌ CRITIQUE: Token n\'a PAS été sauvegardé!');
      console.error('   localStorage disponible?', typeof localStorage !== 'undefined');
      throw new Error('Token not saved in localStorage');
    }

    // Étape 5: Sauvegarder l'utilisateur
    if (userData) {
      const userJson = JSON.stringify(userData);
      localStorage.setItem(this.USER_KEY, userJson);
      localStorage.setItem(this.USER_EMAIL_KEY, userData.email || '');
    } else {
      console.warn('   ⚠️ Pas de userData');
    }

  }

  /**
   * Récupérer le token
   */
  getToken() {
    const token = localStorage.getItem(this.TOKEN_KEY);
    return token;
  }

  /**
   * Récupérer l'utilisateur
   */
  getUser() {
    const userStr = localStorage.getItem(this.USER_KEY);
    
    if (!userStr) {
      return null;
    }

    try {
      const user = JSON.parse(userStr);
      return user;
    } catch (error) {
      console.warn('      ❌ Parse error:', error.message);
      return null;
    }
  }

  /**
   * SIMPLE CHECK: Authentifié?
   */
  isAuthenticated() {
    const token = this.getToken();
    const hasToken = !!token;

    const user = this.getUser();
    const hasUser = !!user;

    const hasSession = localStorage.getItem(this.SESSION_KEY) === 'true';

    const isAuth = (hasToken && hasUser) || (hasSession && hasUser);
    
    return isAuth;
  }

  /**
   * Déconnexion
   */
  logout() {
    localStorage.removeItem(this.TOKEN_KEY);
    localStorage.removeItem(this.USER_KEY);
    localStorage.removeItem(this.USER_EMAIL_KEY);
    localStorage.removeItem(this.SESSION_KEY);
    sessionStorage.clear();
  }

  /**
   * Diagnostic simple mais complet
   */
  diagnose() {
    const isAuth = this.isAuthenticated();
    return isAuth;
  }

  /**
   * Nettoyer complètement
   */
  async clearAllCaches() {
    localStorage.clear();
    sessionStorage.clear();
    
    if ('caches' in window) {
      const names = await caches.keys();
      for (const name of names) {
        await caches.delete(name);
      }
    }
  }
}

export default new AuthService();
